/**
 * Cargadores de las páginas con división de código.
 *
 * App.tsx los usa con `React.lazy` y la navegación los llama al pasar el
 * puntero o el dedo por un enlace (`prefetchRoute`): el import dinámico es el
 * mismo, así que el chunk que se descarga por adelantado es exactamente el que
 * React pedirá después, y al hacer clic la página ya está en memoria.
 */
export const routeLoaders = {
  overview: () => import("@/pages/OverviewPage"),
  network: () => import("@/pages/NetworkPage"),
  climate: () => import("@/pages/ClimatePage"),
  analysis: () => import("@/pages/AnalysisPage"),
  alerts: () => import("@/pages/AlertsPage"),
  registration: () => import("@/pages/RegistrationPage"),
  actuators: () => import("@/pages/ActuatorsPage"),
  rules: () => import("@/pages/RulesPage"),
  systemSettings: () => import("@/pages/SystemSettingsPage"),
  usersManagement: () => import("@/pages/UserManagementPage"),
  profile: () => import("@/pages/ProfilePage"),
  integrations: () => import("@/pages/IntegrationsPage"),
  crops: () => import("@/pages/CropsPage"),
  devices: () => import("@/pages/DevicesPage"),
  imageAnalysis: () => import("@/pages/ImageAnalysisPage"),
} as const;

const loadersByPath: Record<string, () => Promise<unknown>> = {
  "/": routeLoaders.overview,
  "/network": routeLoaders.network,
  "/climate": routeLoaders.climate,
  "/analysis": routeLoaders.analysis,
  "/alerts": routeLoaders.alerts,
  "/registration": routeLoaders.registration,
  "/actuators": routeLoaders.actuators,
  "/rules": routeLoaders.rules,
  "/system-settings": routeLoaders.systemSettings,
  "/users-management": routeLoaders.usersManagement,
  "/profile": routeLoaders.profile,
  "/integrations": routeLoaders.integrations,
  "/crops": routeLoaders.crops,
  "/devices": routeLoaders.devices,
  "/image-analysis": routeLoaders.imageAnalysis,
};

const requested = new Set<string>();

/**
 * Descarga por adelantado el chunk de una ruta. Idempotente y silencioso: un
 * fallo (sin red, despliegue nuevo) no debe romper nada; el `React.lazy` real
 * volverá a intentarlo al navegar y su error lo recoge el ErrorBoundary.
 */
export function prefetchRoute(path: string): void {
  const loader = loadersByPath[path];
  if (!loader || requested.has(path)) return;
  requested.add(path);
  loader().catch(() => {
    requested.delete(path);
  });
}
